
import { Image } from 'utils'
import { Animation } from 'animation'
import { TYPE, canGo } from 'network/server_tool'
import { REQUEST_TYPE } from 'network/net'
import { get_prop } from 'utils'
import { action, live, clear_action } from 'actions'

export function balls( space, container, settings )
{
    const X = [ 66, 279, 493, 706, 920 ]
    const Y = 125
    const Y_DELTA = 197
    const SPEED = 1700

    const balls = []
    const balls_container = new PIXI.Container
    container.addChild( balls_container )

    const mask = new PIXI.Graphics
    mask.position.set( X[ 0 ], Y )
    mask.beginFill( 0xFFFFFF )
    mask.drawRect(
        0,
        0,
        X[ 4 ] - X[ 0 ] + ( X[ 4 ] - X[ 3 ] ),
        Y_DELTA * 3,
    )
    mask.endFill()
    balls_container.mask = mask
    balls_container.addChild( mask )

    const FRAMES = 6

    let roll_music = null;
    if (settings.slot.roll_music) {
        roll_music = sounds.get(settings.slot.roll_music)
    }
    let ball_stop_sound = null;
    if (settings.slot.ball_stop_sound) {
        ball_stop_sound = sounds.get(settings.slot.ball_stop_sound)
    }
    let ball_away_sound = null;
    if (settings.slot.ball_away_sound) {
        ball_away_sound = sounds.get(settings.slot.ball_away_sound)
    }

    function dispose(){
        for ( const b of balls ) b.anim.destroy( { children : true } )
        balls.length = 0
    }

    function make_balls( symbols )
    {
        dispose()

        for ( let i = 0; i < symbols.length; ++ i )
        {
            const ball = {}

            const symbol = symbols[ i ]
            ball.anim = Animation.byFrameName( settings.slot.balls.replace( new RegExp( '{symbol}', 'g' ), symbol ), FRAMES )
            balls_container.addChild( ball.anim )

            balls.push( ball )
        }
    }

    space.s( 'sportbet:rollout' ).on( state => {
        make_balls( state.state.stage.math.symbols )

        t = 0
        end = false
        lastColumnStop = -1;
        draw()
    } )
    space.s( 'sportbet:rollout' )
        .with(space.s( 'sportbet:table_mode' ), (_, isTable) => isTable)
        .filter(is => !is)
        .on(() => {
            if (roll_music) {
                roll_music.play();
            }
        })

    let t = -1
    let end
    let lastColumnStop = -1;

    space.s( 'ticker' ).on( s => {
        if ( t >= 0 ) {
            t += s
            const ended = draw()
            if ( ended ) {
                t = -1
                end = true
                space.s( 'sportbet:balls_rolled' ).next()
            }
        }
    } )

    space.s( 'sportbet:column_stop' )
        .with(space.s( 'sportbet:table_mode' ), (_, isTable) => isTable)
        .filter(is => !is)
        .on(() => {
            if (ball_stop_sound) {
                ball_stop_sound.play();
            }
        })

    space.s( 'sportbet:rollout' )
        .map( () => true )
        .to( space.s( 'sportbet:balls_rolling' ) )
    space.s( 'sportbet:balls_rolled' )
        .map( () => false )
        .to( space.s( 'sportbet:balls_rolling' ) )

    function get_ball( i ) {
        const row = i % 3
        const column = Math.floor( i / 3 )
        return {
            ball : balls[ i ],
            row,
            column,
            start : Y + Y_DELTA * ( row - 4 ) - column * Y_DELTA * 2.5,
            target : Y + Y_DELTA * row,
        }
    }

    function draw()
    {
        let ended = true
        for ( let i = 0; i < balls.length; ++ i )
        {
            const { ball, row, column, start, target } = get_ball( i )

            const LAST = 260

            const pos = start + SPEED * t
            if ( pos < target + LAST && ! end ) ended = false
            if (pos >= target && row === 2 && column > lastColumnStop) {
                lastColumnStop = column;
                space.s( 'sportbet:column_stop' ).next(column);
            }
            const y = pos > target || end ? target : pos
            ball.anim.position.set( X[ column ], y )

            //в последний момент начинает играть анимация остановки шара:
            let yy = pos > (target + LAST) ? target + LAST : pos;
            let frame = 0 + Math.max( 0, ( yy - ( target - LAST / 2  ) ) / ( LAST / ( FRAMES - 1 ) ) )
            if (end || frame >= FRAMES) {
                frame = FRAMES - 1;
            }
            ball.anim.gotoAndStop( frame )
        }
        return ended
    }

    //restore:
    space.s( 'net' )
        .filter( net =>
            net.state.state.stage.type != TYPE.REGULAR
            &&
            get_prop( net, [ 'state', 'state', 'stage', 'math', 'symbols' ] )
        )
        .take( 1 )
        .on( net => {
            make_balls( net.state.state.stage.math.symbols )
            end = true
            draw()
        } )

    //roll away:
    const actions = []
    space.s( 'ticker' ).on( seconds => {
        for ( const a of actions ) live( a, seconds )
    } )
    const AWAY_SPEED = 400
    const AWAY_ACC = 8800
    space.s( 'sportbet:roll_away' )
        .filter( a => a )
        .on( () => {
            for ( let i = 0; i < 3; ++ i ){
                const queue = action()

                //wait before other balls roll away:
                queue.push({ duration : 0.1 * i })
                queue.push({ duration : 999, callback : karet => {
                    for ( let j = 0; j < balls.length; ++ j ) {
                        const { ball, row, target } = get_ball( j )
                        if ( row != 2 - i ) continue
                        ball.anim.position.y = target + karet * AWAY_SPEED + AWAY_ACC * karet * karet / 2
                    }
                }} )
                actions.push( queue )
            }

            //wait for all the balls to roll away and finish:
            const finish = action()
            finish.push({ duration : 0.8 })
            finish.push({ callback : () => {
                dispose()
                for ( const a of actions ) clear_action( a )
                actions.length = 0
                space.s( 'sportbet:roll_away' ).next( false )
            }} )
            actions.push( finish )

        } )

    space.s( 'sportbet:roll_away' )
        .with(space.s( 'sportbet:table_mode' ), (_, isTable) => isTable)
        .filter(is => !is)
        .on(() => {
            if (ball_away_sound) {
                ball_away_sound.play();
            }
        })
}

export function mini_balls_desk( global, space, container, settings )
{
    const SPEED = 420
    const WIDTH = 42

    const balls = []
    function reset() {
        for ( const b of balls ) b.container.destroy( { children : true } )
        balls.length = 0
    }
    space.s( 'reset' ).on( reset )

    const balls_container = new PIXI.Container
    container.addChild( balls_container )

    const steel = Image( 'res/games/mini_balls/for_balls.png' )
    steel.position.set( 113, 734 )
    container.addChild( steel )

    let t = -1
    let end
    const START = 774
    const END = START - WIDTH * 15 - 30
    global.s( 'ticker' ).on( s => {
        for ( const b of balls ) {
            if ( b.away < 0 ) {
                b.t += s
                draw( b )
            }
        }
    } )

    //rolling away:
    const AWAY_SPEED = 50
    const AWAY_ACC = 3000
    let away_t = -1
    global.s( 'ticker' ).on( seconds => {
        const d = 1600 * seconds
        for ( const b of balls ) {
            if ( b.away >= 0 ) {
                b.container.position.x -= d
                if ( b.rotating ) b.rotating.rotation -= d / ( WIDTH / ( Math.PI / 2 ) )
            }
        }
    } )
    space.s( 'away' ).on( () => {
        for ( const b of balls ) {
            b.t = -1
            b.away = 0
        }
    } )

    function draw( b )
    {
        let finish = false
        let x = START - b.t * SPEED
        if ( b.ended || x < END + b.i * WIDTH ) {

            //условие, что выкатился послкдний шар
            if (!b.ended && b === balls[balls.length - 1]) {
                space.s('end_roll').next();
            }

            x = END + b.i * WIDTH
            finish = true;
            b.ended = true;
        }
        b.container.position.set( x, 711 )

        b.container.visible = x < START

        if ( b.rotating ) {
            //почему-то в конце все шары совсем чуть-чуть наклонены (возможно из-за float'овой арифметики?):
            if ( finish ) b.rotating.rotation = 0
            else b.rotating.rotation =
                //координата, находясь в которой шар должен иметь нулевое вращение:
                ( x - ( END + WIDTH * b.i ) )
                /
                //π радиан - это полный оборот шара:
                ( WIDTH / ( Math.PI / 2 ) )
        }
    }

    space.s( 'balls' ).on( balls_desc => {
        if ( balls_desc.reset ) reset()

        for ( let bi in balls_desc.balls ) {
            const ball = {}
            const bd = balls_desc.balls[ bi ]
            ball.i = balls.length
            ball.ended = bd.ended
            ball.t = - bi * ( WIDTH / SPEED )
            ball.away = -1

            ball.container = new PIXI.Container
            ball.container.visible = false
            balls_container.addChild( ball.container )

            if ( ! bd.no_rotating ) {
                ball.rotating = Image( settings.slot.mini_balls_rotating.replace( new RegExp( '{symbol}', 'g' ), bd.s ) )
                ball.rotating.anchor.set( 0.5 )
                ball.rotating.position.set( ball.rotating.width / 2, ball.rotating.height / 2 )
                ball.container.addChild( ball.rotating )
            }

            ball.flash = Image( settings.slot.mini_balls_flash.replace( new RegExp( '{symbol}', 'g' ), bd.s ) )
            ball.container.addChild( ball.flash )

            balls.push( ball )
        }

        for ( const b of balls ) draw( b )
    } )

    //mask to crop at left screen border:
    const mask = new PIXI.Graphics
    mask.beginFill( 0xFFFFFF )
    mask.drawRect( 0, 0, 1920, 1080 )
    mask.endFill()
    balls_container.mask = mask
    balls_container.addChild( mask )
}

export function mini_balls( space, container, settings )
{
    mini_balls_desk( space, space.child( 'sportbet:main_mini_balls' ), container, settings )

    function make_balls( symbols, ended )
    {
        //must be displayed row-wise instead of server's column-wise:
        const rotated = []
        for ( let si = 0; si < symbols.length; ++ si )
        {
            rotated[ ( si % 3 ) * 5 + Math.floor( si / 3 ) ] = symbols[ si ]
        }

        return {
            reset : true,
            balls : rotated.map( s => ({ s, ended }) ),
        }
    }

    space.s( 'sportbet:rollout' )
        .map( state => make_balls( state.state.stage.math.symbols ) )
        .to( space.s( 'sportbet:main_mini_balls:balls' ) )

    //restore:
    space.s( 'net' )
        .filter( net =>
            net.state.state.stage.type != TYPE.REGULAR
            &&
            get_prop( net, [ 'state', 'state', 'stage', 'math', 'symbols' ] )
        )
        .take( 1 )
        .map( net => make_balls( net.state.state.stage.math.symbols, true ) )
        .to( space.s( 'sportbet:main_mini_balls:balls' ) )

    if ( settings.slot.a1_a15 ) {
        const a1a15 = Image( settings.slot.a1_a15 )
        a1a15.anchor.set(0.5, 0.5);
        a1a15.position.set( 133 + 299, 691 + 12 )
        a1a15.scale.set(1.03);
        container.addChild( a1a15 )
    }

    space.s( "request" )
        .with(space.s('state'), (request, state) => ({request, state}))
        .filter(({request, state}) => request.type == REQUEST_TYPE.SPIN || (canGo( TYPE.FREEGAME, state.state ) && request.type == REQUEST_TYPE.PROCEED))
        .to( space.s( 'sportbet:main_mini_balls:away' ) )
}



// WEBPACK FOOTER //
// ./src/games/balls.es6